import { render, staticRenderFns } from "./BaseDashboardTableCell.vue?vue&type=template&id=fda75320"
import script from "./BaseDashboardTableCell.vue?vue&type=script&lang=js"
export * from "./BaseDashboardTableCell.vue?vue&type=script&lang=js"
import style0 from "./BaseDashboardTableCell.vue?vue&type=style&index=0&id=fda75320&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports